import moment from 'moment';

/**
 * Function that returns formatted date base on language.
 * Format have to be declared here for each language
 * if not default one will be displayed.
 */

const BASE_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
const GERMAN_DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';
const DEFAULT_DATETIME_FORMAT = 'MMM DD, YYYY HH:mm';
const GERMAN_DATEONLY_FORMAT = 'DD.MM.YYYY';
const DEFAULT_DATEONLY_FORMAT = 'MMM DD, YYYY';

export function parseDateBaseFormat(date) {
    return moment(date, BASE_DATETIME_FORMAT);
}

export function displayLanguageFormattedDate(date, language, includeHour = true) {
    if (date === null || typeof date === 'undefined') { return ''; }

    const momentDate = parseDateBaseFormat(date);

    if (language === 'de') {
        return includeHour ? momentDate.format(GERMAN_DATETIME_FORMAT) : momentDate.format(GERMAN_DATEONLY_FORMAT);
    }
        return includeHour ? momentDate.format(DEFAULT_DATETIME_FORMAT) : momentDate.format(DEFAULT_DATEONLY_FORMAT);
}
